<template>
  <svg width="57px" height="58px" viewBox="0 0 57 58" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 62 (91390) - https://sketch.com -->
    <!--title>draggable copy 2</title-->
    <desc>Created with Sketch.</desc>
    <defs>
      <ellipse id="path-1" cx="16.4415337" cy="15.5" rx="14.4415337" ry="15.5"></ellipse>
      <filter x="-13.8%" y="-12.9%" width="134.6%" height="132.3%" filterUnits="objectBoundingBox" id="filter-2">
        <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
        <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
        <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter2"></feOffset>
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter2" result="shadowBlurOuter2"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0.880286397   0 0 0 0 0.885493323   0 0 0 0 0.889832428  0 0 0 1 0" type="matrix" in="shadowBlurOuter2" result="shadowMatrixOuter2"></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="shadowMatrixOuter2"></feMergeNode>
        </feMerge>
      </filter>
    </defs>
    <g id="02.1_Archetypen-Fragebogen" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="02-Archetyp-Step-by-step_03.2-risikoneidung-active" transform="translate(-354.000000, -491.000000)">
        <g id="Group-4" transform="translate(0.000000, 284.000000)">
          <g id="draggable-copy-5" transform="translate(355.000000, 208.000000)">
            <g id="draggable-copy" stroke-width="1">
              <g id="active-copy">
                <g id="draggables-/-dragger">
                  <g id="Group-8" transform="translate(11.692383, 11.875000)">
                    <g id="Group-3">
                      <circle id="Oval" stroke="#E84B3D" stroke-width="4" fill="#FFFFFF" fill-rule="nonzero" cx="16.2444661" cy="15.5" r="13.5"></circle>
                    </g>
                  </g>
                  <ellipse id="Oval" stroke="#F05741" stroke-width="1.30232558" opacity="0.100000001" fill-rule="nonzero" cx="27.5333333" cy="28" rx="27.5333333" ry="28"></ellipse>
                  <ellipse id="Oval" stroke="#F05741" stroke-width="1.30232558" opacity="0.2" fill-rule="nonzero" cx="27.5333333" cy="28" rx="21" ry="21.1627907"></ellipse>
                </g>
              </g>
            </g>
            <circle id="Oval" fill="#E84B3D" opacity="0.400000006" cx="27.936849" cy="27.375" r="4"></circle>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
